// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Modal_confirm__J5jC5","container":"Modal_container__3Wm3u"};